import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Add } from '@carbon/react/icons';
import { Button } from '@carbon/react';
import { PageHeader } from 'components/page-header';
import routes from '~/routes';
import PriceDecksContent from './price-decks-content';

const PriceDecksPage: FC = () => {
  const history = useHistory();

  return (
    <>
      <PageHeader
        breadcrumbs={[]}
        title="Price Decks"
        actions={
          <Button
            renderIcon={Add}
            kind="primary"
            onClick={() => history.push(routes.priceDecksNewPath)}
          >
            Add Price Deck
          </Button>
        }
      />
      <PriceDecksContent />
    </>
  );
};

export { PriceDecksPage };
